import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStylesSmall } from "../utils/CommonStyles.js";

let appSurveyOptions = [];
let locationOptions = [];
let supplierDateOptions = [];

function SupplierAppSurveyTableRow({ index, companySurveyList, buyerLocations, supplierDates, handleSubmit, setError, t, setAdd, oddIdx }) {
    const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
    const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: "", value: 0 });
    const [locationLoaded, setLocationLoaded] = useState(false);
    const [locationsSelected, setLocationsSelected] = useState([]);
    const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);
    const canReadRef = useRef(null);
    const [isCanRead, setIsCanRead] = useState(false);
    const canWriteRef = useRef(null);
    const [isCanWrite, setIsCanWrite] = useState(false);
    const priorityToBuyerScoreRef = useRef(null);
    const [isPriorityToBuyerScore, setIsPriorityToBuyerScore] = useState(false);

    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        setAppSurveyValues(companySurveyList);
        setLocations(buyerLocations);
        setSupplierDates(supplierDates);
    }, []);

    function setAppSurveyValues(appSurveyObj) {
        let appSurveyValue = {};
        appSurveyOptions = [];
        if (appSurveyObj && appSurveyObj.length > 0) {
            appSurveyObj.map((aAppSurvey, idx) => {
                appSurveyValue.label = aAppSurvey.surveyDisplayName;
                appSurveyValue.value = aAppSurvey.appSurveyKey;
                appSurveyOptions.push(appSurveyValue);
                if (idx == 0) {
                    setAppSurveySelected({ ...appSurveySelected, label: (appSurveyValue.label), value: aAppSurvey.appSurveyKey });
                }
                appSurveyValue = {};
            });
            setAppSurveyLoaded(true);
        }
    }
    const appSurveyHandler = (selectedOption, action) => {
        let appSurveyKey = selectedOption ? selectedOption.value : 0;
        let appSurveyLabel = selectedOption ? selectedOption.label : "";
        setAppSurveySelected({ ...appSurveySelected, label: (appSurveyLabel), value: appSurveyKey });
    }
    
    function setLocations(buyerLocationList) {
        let locationValue = {};
        locationOptions = [];
        if (buyerLocationList && buyerLocationList.length > 0) {
            buyerLocationList.map((aBuyerLocation, idx) => {
                locationValue.label = aBuyerLocation.departmentName + " - " + aBuyerLocation.locationName;
                locationValue.value = aBuyerLocation.locationKey;
                locationOptions.push(locationValue);
                locationValue = {};
            });
            setLocationLoaded(true);
        }
    }
    const locationHandler = (selectedOptions) => {
		//console.log(selectedOptions);
        setLocationsSelected(selectedOptions);
    }
    
    function setSupplierDates(supplierDatesList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        if (supplierDatesList && supplierDatesList.length > 0) {
            supplierDatesList.map((aSupplierDate, idx) => {
                supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
		//console.log(selectedOptions);
        setSupplierDatesSelected(selectedOptions);
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("canRead_")) {
            setIsCanRead(event.target.checked);
        } else if (name.startsWith("canWrite_")) {
            setIsCanWrite(event.target.checked);
        } else if (name.startsWith("priorityToBuyerScore_")) {
            setIsPriorityToBuyerScore(event.target.checked);
        } 
    }

    function submitComplete() {
        setIsSubmit(false);
        setIsCanRead(false);
        setIsCanWrite(false);
        setIsPriorityToBuyerScore(false);
        setLocationsSelected([]);
        setSupplierDatesSelected([]);
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let initialValues = {
            appSurveyKey: appSurveySelected.value,
            canRead: canReadRef.current.checked,
            canWrite: canWriteRef.current.checked,
            priorityToBuyerScore: priorityToBuyerScoreRef.current.checked,
            locationKeys: locationsSelected.map(option => option.value),
            partnershipDateKeys: supplierDatesSelected.map(option => option.value),
        };

        if (!appSurveySelected.value || appSurveySelected.value === 0) {
            setError(t("error.appSurveyNameReqd"));
            setIsSubmit(false);
        } else {
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setIsCanRead(false);
        setIsCanWrite(false);
        setIsPriorityToBuyerScore(false);
        setLocationsSelected([]);
        setSupplierDatesSelected([]);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {appSurveyLoaded ? <Select
                    name="appSurveyKey"
                    options={appSurveyOptions}
                    onChange={appSurveyHandler}
                    placeholder={""}
                    value={appSurveySelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="appSurveyKey-input"
                    styles={ddStylesSmall}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {locationLoaded ? <Select
                    name="locationKey"
                    options={locationOptions}
                    onChange={locationHandler}
                    placeholder={""}
                    value={locationsSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="locationKey-input"
                    isMulti
                    styles={ddStylesSmall}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {supplierDateLoaded ? <Select
                    name="supplierDateKey"
                    options={supplierDateOptions}
                    onChange={supplierDateHandler}
                    placeholder={""}
                    value={supplierDatesSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="supplierDateKey-input"
                    isMulti
                    styles={ddStylesSmall}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReadRef}
                    name={"canRead_0"}
                    id={"canRead_0"}
                    defaultChecked={true}
                    checked={isCanRead}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canWriteRef}
                    name={"canWrite_0"}
                    id={"canWrite_0"}
                    defaultChecked={true}
                    checked={isCanWrite}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={priorityToBuyerScoreRef}
                    name={"priorityToBuyerScore_0"}
                    id={"priorityToBuyerScore_0"}
                    defaultChecked={true}
                    checked={isPriorityToBuyerScore}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {(appSurveyOptions && appSurveyOptions.length > 0) ?
                    (<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
                    :
                    (<></>)
                }
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default SupplierAppSurveyTableRow;